<script setup lang="ts">
import { DropdownMenuItem } from 'reka-ui'
</script>

<template>
  <DropdownMenuItem
    class="flex min-h-[var(--density-target-min)] w-full cursor-pointer select-none items-center gap-[var(--space-cell)] rounded-[var(--radius-control)] px-[var(--space-cell)] py-[var(--space-inline)] text-left text-[length:var(--text-step-3)] text-[color:var(--color-text)] outline-none data-[highlighted]:bg-[color:var(--color-surface-raised)]"
  >
    <slot />
  </DropdownMenuItem>
</template>
